/**
 * permission
 *
 * @author Shigq
 * @date 2021/4/14 15:49
 */
import router from '@/router'
import store from '@/store'
import { routesWhiteList, tokenName, title } from '@/config/setting.config'
import { cookieUtils, vab } from '@libs/utils'
import { getStaticConfig, getRegInfo, getListDictionaryMapping } from '@/utils/common-req'
import { useI18n } from "@/plugins/i18n"
const { t } = useI18n()

/**
 * init config
 *
 * @param next
 * @param to
 * @returns {Promise<void>}
 */
let errorMessageShown = false;
const initConfig = async (next, to) => {
  await getRegInfo()
  await getListDictionaryMapping()
  if (
    (store.state.auth.registerInfo?.kycReviewStatus !== 'CF' ||
    ((+store.state.auth.registerInfo?.regType === 2) && store.state.auth.registerInfo?.agreementReviewStatus !== 'CF')) &&
    (!to.path.includes('/auth') && to.path !== '/dashboard')
  ) {
  // 只有当错误提示尚未显示时，才显示错误提示
    if (!errorMessageShown) {
      vab.baseMessage(t('global.content.text_7'), 'error')
      errorMessageShown = true;
      // 3秒后重置标志，允许再次显示错误提示
      setTimeout(() => {
        errorMessageShown = false;
      }, 3000);
    }
    next({ path: '/dashboard' })
  } else {
    next()
  }
}

/**
 * init router
 *
 * @param next
 * @param to
 * @returns {Promise<void>}
 */
const initRouter = async (next, to) => {
  try {
    // 获取动态路由
    const accessRoutes = await store.dispatch('routes/initRoutes')

    accessRoutes.forEach(route => {
      router.addRoute(route)
    })

    next({ ...to, replace: true })
  } catch (e) {
    next({ path: '/login' })
  }
}

router.beforeEach(async (to, from, next) => {
  // todo - 获取静态配置信息
  await getStaticConfig()

  // todo - 权限
  if (to.path === '/login') {
    next()
  } else {
    // roles
    const hasRoles = cookieUtils.getCookie(tokenName)

    if (hasRoles) {
      // routes
      const hasRoutes = store.state.routes.addRoutes && store.state.routes.addRoutes.length > 0

      if (hasRoutes) {
        if (routesWhiteList.includes(to.path)) {
          next()
        } else {
          await initConfig(next, to)
        }
      } else {
        await initRouter(next, to)
      }
    } else {
      // 白名单
      if (routesWhiteList.includes(to.path)) {
        next()
      } else {
        next({ path: '/login' })
      }
    }
  }
})

router.afterEach(function(to) {
  if (to.meta.title) {
    document.title = `${to.meta.title} | ${title}`
  }

  if (to.meta.nav) {
    store.dispatch('routes/setNavRouteIndex', to.path)
  }
})
